import { render, staticRenderFns } from "./VirtualMachineEdit.vue?vue&type=template&id=52d09dee&scoped=true&"
import script from "./VirtualMachineEdit.vue?vue&type=script&lang=js&"
export * from "./VirtualMachineEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d09dee",
  null
  
)

export default component.exports